import styled from 'styled-components'

export const PolicyContainer = styled.div`
  width: 100%;
  background-color: #02e5ff;
  color: #fff;
  min-height: calc(100vh - 80px); /* Adjust based on header */
  box-sizing: border-box;
  font-family: inherit;
  position: relative;
  display: flex;
  flex-direction: column;
`

export const PageHeader = styled.div`
  text-align: center;
  padding: 60px 20px 40px;
`

export const PageTitle = styled.h1`
  color: #fff;
  font-size: 3rem;
  font-weight: 900;
  text-transform: uppercase;
  margin: 0;
  text-shadow: 0 0 10px rgba(252,10,126,1), 0 0 20px rgba(252,10,126,0.8), 0 0 40px rgba(252,10,126,0.5);
  letter-spacing: 2px;
`

export const PageSubtitle = styled.p`
  color: #fff;
  font-size: 1.1rem;
  margin-top: 15px;
`

export const TopDivider = styled.div`
  width: 100%;
  border-bottom: 1px solid #0abde3;
`

export const BottomDivider = styled.div`
  width: 100%;
  border-bottom: 1px solid #0abde3;
  margin-top: 20px;
  margin-bottom: 40px;
`

export const ContentContainer = styled.div`
  padding: 60px 10%;
  position: relative;
  max-width: 1200px;
  margin: 0 auto;
  flex: 1;
  width: 100%;
`

export const Section = styled.div`
  margin-bottom: 50px;
  position: relative;
  z-index: 2;
  text-align: left;
`

export const SectionTitle = styled.h2`
  color: #00cfff;
  font-size: 2rem;
  font-style: italic;
  font-weight: 900;
  margin: 0 0 15px 0;
  text-transform: uppercase;
  text-shadow: 0 0 8px rgba(0,207,255,0.8), 0 0 15px rgba(0,207,255,0.5);
`

export const SectionText = styled.p`
  font-size: 1rem;
  margin: 0 0 15px 0;
  line-height: 1.6;
`

export const HighlightText = styled.span`
  color: #fff000;
  text-decoration: underline;
`

export const NormalText = styled.span`
  color: #fff;
`

export const BulletList = styled.ul`
  list-style-type: none;
  padding: 0;
  margin: 0 0 20px 0;
`

export const BulletItem = styled.li`
  color: #fff;
  font-size: 1rem;
  line-height: 1.6;
  margin-bottom: 15px;
  position: relative;
  padding-left: 20px;

  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 8px;
    width: 6px;
    height: 6px;
    background-color: #00cfff;
    border-radius: 50%;
    box-shadow: 0 0 6px rgba(0,207,255,1);
  }
`

export const BackgroundWatermark = styled.div`
  position: absolute;
  right: 15%;
  bottom: -40px;
  width: 250px;
  height: 400px;
  opacity: 0.05;
  background-image: url(${props => props.img});
  background-size: contain;
  background-position: bottom;
  background-repeat: no-repeat;
  z-index: 1;
  pointer-events: none;
`
